import { render, staticRenderFns } from "./KaiEditor.vue?vue&type=template&id=5b40b28c&scoped=true&"
import script from "./KaiEditor.vue?vue&type=script&lang=ts&"
export * from "./KaiEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b40b28c",
  null
  
)

export default component.exports